export const courseReducer = (state = {}, action) => {
    switch (action.type) {
        case "GETCOURSE":
            return { ...action.payload }
        default:
            return state;

    }
}